module.exports = "/assets/data/6ead9fedbc544f154498b60afbb1b0fa-NR7.data.json";